import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { EEOCategoriesEffects, EEOEffects } from './store/eeo.effects';
import {
  EEOCategoriesNamespace,
  EEOCategoriesReducer,
  EEONamespace,
  EEOReducer,
} from './store/eeo.store';

@NgModule({
  imports: [
    StoreModule.forFeature(EEONamespace, EEOReducer),
    StoreModule.forFeature(EEOCategoriesNamespace, EEOCategoriesReducer),
    EffectsModule.forFeature([EEOEffects, EEOCategoriesEffects]),
  ],
})
export class EEODataModule {}
